const firebaseConfig = {
    apiKey: "AIzaSyAEYMqP6r8skmLUvk8nLOOZQVk0i0nJQ2U",
    authDomain: "crypto-world-69c62.firebaseapp.com",
    projectId: "crypto-world-69c62",
    storageBucket: "crypto-world-69c62.appspot.com",
    messagingSenderId: "980452692366",
    appId: "1:980452692366:web:5e2c2781e73db5e54d14df"
  };

  export default firebaseConfig;